"use strict";
/**
 * **What HVP decides about QVET's warehouses and sections.** GH527 · SP8.
 *
 * Both became class-C entities on 2026-09-11 (`.claude/rules/modelos-y-qvet.md`): QVET's own
 * fields live in a `qvetSync` block and ours in `hvpData`, inside one document. These are the
 * requests that edit **our half** — QVET's half is never written from here; the daily sync owns
 * it, and it cannot touch ours.
 *
 * Until today the only way to change any of this was editing the database by hand.
 */
Object.defineProperty(exports, "__esModule", { value: true });
